import { APIRuntimeBuilder } from '@cian/mf-registry/browser';

import { TDispatch, TReduxStore } from '../../../shared/types/redux';
import { setModalOpen } from 'shared/slices/modal';

export function buildAPIRuntime(store: TReduxStore): APIRuntimeBuilder {
  return [
    {
      path: '/v1/open-all-filters-modal',
      handler: async () => (store.dispatch as TDispatch)(setModalOpen(true)),
    },
    {
      path: '/v1/close-all-filters-modal',
      handler: async () => (store.dispatch as TDispatch)(setModalOpen(false)),
    },
  ];
}
